import { LocaleSpecification } from 'moment'
import { isMobileBrowser } from '@src/util/functions'

export const defaultDaysNumber = 7
export const WorkoutTypes: string[] = ['home', 'station']

export enum NotificationTypes {
  CONFIRM = 'confirm',
  NOTIFY = 'notify'
}

export const weekDays = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday']

export const locales3D = ['de-de', 'en-gb', 'fr-fr', 'fi-fi', 'nl-nl', 'it-it', 'ja-jp', 'pl-pl', 'sv-se', 'el-gr', 'pt-pt', 'es-es', 'tr-tr', 'ar-arab']
export const locales2D = ['de-de', 'en-us', 'ja-jp', 'fr-fr', 'fi-fi', 'nl-nl', 'it-it', 'en-gb', 'el-gr', 'pt-pt', 'es-es', 'tr-tr', 'ar-arab']
export const availableEquipment = ['dumbbells', 'bench', 'medicine_ball', 'box', 'theraband', 'kettlebells', 'stability_ball', 'barbell', 'stick', 'water_bottle', 'walking_bar', 'stool', 'chair', 'wall']

export enum TaskStatus {
  PLANNED = 'planned',
  IN_PROGRESS = 'in_progress',
  LATER = 'later',
  DONE = 'done'
}

// used to display filters for retention flags;each array item is mapped to translation keys from 'PAGE.MEMBERS.LIST.HEADERS.RETENTION_FLAGS.FILTERS'
export const retentionFlags: string[] = ['allMembers', 'easyWorkoutAlert', 'attendanceAlert14', 'attendanceAlert30', 'attendanceAlert60', 'staleWorkoutAlert', 'exercisesToChange', 'termsReacceptanceRequired', 'currentWorkoutAlert', 'plannedCheckupAlert', 'staleCheckupAlert']

export const UI_RETENTION_FLAG_TO_BACKEND_FLAG = {
  'easyWorkoutAlert': 'with_easy_workout_alert',
  'attendanceAlert14': 'with_attendance_14_days_alert',
  'attendanceAlert30': 'with_attendance_30_days_alert',
  'attendanceAlert60': 'with_attendance_60_days_alert',
  'staleWorkoutAlert': 'with_stale_workout_alert',
  'exercisesToChange': 'with_exercises_to_change_up_alert',
  'exercisesToChangeUp': 'with_exercises_to_change_up_alert',
  'exercisesToChangeDown': 'with_exercises_to_change_down_alert',
  'termsReacceptanceRequired': 'with_terms_reacceptance_required',
  'currentWorkoutAlert': 'with_current_workout_alert',
  'staleCheckupAlert': 'with_stale_checkup_alert',
  'plannedCheckupAlert': 'with_planned_checkup_alert'
}

export const BACKEND_RETENTION_FLAG_TO_UI_FLAG = {
  'with_easy_workout_alert': 'easyWorkoutAlert',
  'with_attendance_14_days_alert': 'attendanceAlert14',
  'with_attendance_30_days_alert': 'attendanceAlert30',
  'with_attendance_60_days_alert': 'attendanceAlert60',
  'with_stale_workout_alert': 'staleWorkoutAlert',
  'with_exercises_to_change': 'exercisesToChange',
  'with_exercises_to_change_up_alert': 'exercisesToChangeUp',
  'with_exercises_to_change_down_alert': 'exercisesToChangeDown',
  'with_terms_reacceptance_required': 'termsReacceptanceRequired',
  'with_current_workout_alert': 'currentWorkoutAlert',
  'with_stale_checkup_alert': 'staleCheckupAlert',
  'with_planned_checkup_alert': 'plannedCheckupAlert'
}

export enum Languages {
  GERMAN = 'de-de',
  ENGLISH_US = 'en-us',
  FRENCH = 'fr-fr',
  FINNISH = 'fi-fi',
  DUTCH = 'nl-nl',
  ITALIAN = 'it-it',
  JAPANESE = 'ja-jp',
  POLISH = 'pl-pl',
  SWEDISH = 'sv-se',
  ENGLISH = 'en-gb',
  GREEK = 'el-gr',
  PORTUGUESE = 'pt-pt',
  SPANISH = 'es-es',
  TURKISH = 'tr-tr',
  ARABIC = 'ar-arab'
}

/**
 * Measuring units for different values.
 * Corresponding unit_denominator:
 * - min: 1
 * - sec: 60
 * - steps: 100
 * - floors: 1
 */
export enum Unit {
  SEC = 'sec',
  MIN = 'min',
  STEPS = 'steps',
  FLOORS = 'floors'
}

export const HealthLimitationGroupsTitles = ['Joints', 'Back', 'Ever_Had', 'bloodPressure']

export const AVAILABLE_LOCALES = ['de-de', 'en-us', 'ja-jp', 'it-it', 'fr-fr', 'fi-fi', 'nl-nl', 'en-gb', 'el-gr', 'pt-pt', 'es-es', 'tr-tr', 'ar-arab']

export const HealthIndicatorOptions: string[] = ['MET', 'PIX_SCORE', 'ACTIVITY', 'STATION', 'HOME', 'MUSCLE_GROUP', 'BODY_AREA', 'TRAINING_FOCUS']

// Map each measurement with a color (to be used for bullets and historical data in tables); colors correspond to the bullet colors set in bullet.sass
export const bulletColorMapping = {
  body_weight: 'blue',
  waistline: 'blue',
  muscle_mass: 'cyan',
  left_bicep_circumference: 'cyan',
  body_fat: 'purple',
  right_bicep_circumference: 'purple',
  body_water_mass: 'yellow',
  right_thigh_circumference: 'yellow',
  body_vfat: 'red',
  left_thigh_circumference: 'red',
  hip_measurement: 'pink',
  chest_circumference: 'yellow-dark',
  OPTIMAL: 'blue',
  NORMAL: 'cyan',
  PREHYPERTENSION: 'yellow',
  HIGH1: 'yellow-medium',
  HIGH2: 'yellow-dark',
  HYPERTENSIVE_CASE: 'red'
}

// colors correspond to the bullet colors set in bullet.sass
export const lineColorMapping = {
  body_weight: '#4FACFE',
  waistline: '#4FACFE',
  OPTIMAL: '#4FACFE',
  muscle_mass: '#72ECB2',
  left_bicep_circumference: '#72ECB2',
  NORMAL: '#72ECB2',
  body_fat: '#A600FF',
  right_bicep_circumference: '#A600FF',
  body_water_mass: '#FFCC2D',
  right_thigh_circumference: '#FFCC2D',
  PREHYPERTENSION: '#FFCC2D',
  body_vfat: '#FF4851',
  left_thigh_circumference: '#FF4851',
  HYPERTENSIVE_CASE: '#FF4851',
  hip_measurement: '#FC297D',
  HIGH1: '#F5A623',
  chest_circumference: '#C57C03',
  HIGH2: '#C57C03'
}

export const DEFAULT_SCREENSAVER_IMAGE = '/assets/icon/brand/screensaver.png'

// supported formats for the screensaver:
export const SUPPORTED_IMAGE_TYPES: string[] = ['jpg', 'jpeg', 'gif', 'png']
export const SUPPORTED_VIDEO_TYPES: string[] = ['mp4', 'webm']
export const SCREENSAVER_SIZE_LIMIT: number = 10 * 1024 * 1024 // 10MB

// the user is allowed to adjust the tempo of an exercise during workout builder, by this percentage (+ & -)
export const ALLOWED_TEMPO_ADJUSTMENT_PERCENTAGE: number = 35

// default duration for a home exercise
export const DEFAULT_DURATION_HOME_EXERCISE: number = 45

// workout preview image size:
export const WORKOUT_PREVIEW_IMG_HEIGHT = 612
export const WORKOUT_PREVIEW_IMG_WIDTH = 1080

export const CHART_LABEL_FONT_STYLE = {
  style: {
    color: '#212121',
    fontSize: '0.875rem'
  }
}

export const CHART_LABEL_TWO_ROWS_FONT_STYLE = {
  fontSize: '15px',
  color: '#212121'
}

export const PROGRESS_COLORS = {
  red: '#FF4851',
  yellow: '#FFCC2D',
  cyan: '#72ECB2'
}

export const DISABLED_FAVORITE_ACTIVITIES: string[] = ['distanceWalkingRunning', 'flightsClimbed', 'stepCount', 'pixWorkout', 'other']

// how many pixels before end of page needed to request next pages
export const BOTTOM_SCROLL_THRESHOLD: number = 100
export const CARDS_ON_BUILDER_PAGE: number = 10

export const localeSpecifications = {
  'en': {
    longDateFormat: {
      L: 'DD/MM/YYYY'
    }
  } as LocaleSpecification,
  'de': {
    longDateFormat: {
      L: 'DD.MM.YYYY'
    }
  } as LocaleSpecification,
  'ja': {
    longDateFormat: {
      L: 'YYYY/MM/DD'
    }
  } as LocaleSpecification,
  'it': {
    longDateFormat: {
      L: 'DD/MM/YYYY'
    }
  } as LocaleSpecification,
  'fr': {
    longDateFormat: {
      L: 'DD/MM/YYYY'
    }
  } as LocaleSpecification,
  'fi': {
    longDateFormat: {
      L: 'DD.MM.YYYY'
    }
  } as LocaleSpecification,
  'nl': {
    longDateFormat: {
      L: 'DD/MM/YYYY'
    }
  } as LocaleSpecification,
  'el': {
    longDateFormat: {
      L: 'DD/MM/YYYY'
    }
  } as LocaleSpecification,
  'pt': {
    longDateFormat: {
      L: 'DD/MM/YYYY'
    }
  } as LocaleSpecification,
  'es': {
    longDateFormat: {
      L: 'DD/MM/YYYY'
    }
  } as LocaleSpecification,
  'tr': {
    longDateFormat: {
      L: 'DD.MM.YYYY'
    }
  } as LocaleSpecification,
  'ar': {
    longDateFormat: {
      L: 'DD/MM/YYYY'
    }
  } as LocaleSpecification
}

export const DRAG_COMMON_SETTING = {
  delay: isMobileBrowser() ? 100 : 0, // how much to hold until drag is activated (milliseconds)
  animation: 200
}

// by default you can drag and drop a modal opened from a draggable component
export const disableDragIfModalsAreOpened = (evt) => {
  const hasModal = document.getElementById('modalComponent')
  if (hasModal) {
    evt.item.draggable = false
    return false
  }
}

export const SCORE_TYPES = ['accuracy', 'tempo', 'range_of_motion', 'pix_score']

export const SCORE_BULLET_COLOR = {
  tempo: 'blue',
  range_of_motion: 'cyan',
  accuracy: 'purple',
  pix_score: 'red'
}

export const NO_EQUIPMENT = 'no_equipment'

export const TERMS_FALLBACK_LOCALE = 'en-gb'

export const DEFAULT_PAGE_SIZE = 10

export const MAX_TABLET_WIDTH = 820

export const MIN_LANDSCAPE_WIDTH = 1025

export const DEFAULT_CHART_WIDTH = '100%'
export const DEFAULT_CHART_HEIGHT = 300

export const DEFAULT_PRINT_CHART_WIDTH = 300
export const DEFAULT_PRINT_CHART_HEIGHT = 300
export const CHART_Y_AXIS_OFFSET = 0.01 // used for displaying chart marker when value = yAxisMinValue
export const APEX_CHARTS_TYPES = {
  AREA: 'area',
  LINE: 'line',
  SCATTER: 'scatter'
}
export const AREA_CHART_DEFAULT_MAX_Y = 3
export const MAX_MOBILE_WIDTH = 600

export const WORKOUT_SIMULTATOR_STATE = {
  PREVIEW: 'PREVIEW',
  RUNNING: 'RUNNING',
  END: 'END'
}

export const MIN_PLAYBACK_RATE = 0.5

export const PLAN_AN_ACTIVITY_KEY = 'PLAN_AN_ACTIVITY'
export const ADD_A_COMPLETED_ACTIVITY_KEY = 'ADD_A_COMPLETED_ACTIVITY'
export const eventSystem = new EventTarget()
